import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import './HeroSection.scss';

interface Props {
  onScrollToPlans: () => void;
}

export function HeroSection({ onScrollToPlans }: Props) {
  const navigate = useNavigate();
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      sectionRef.current.style.backgroundPositionY = `calc(50% + ${window.scrollY * 0.25}px)`;
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="hero-section" ref={sectionRef}>
      <div className="hero-section__content">
        <span className="hero-section__badge">O CLUBE DE LAVAGEM DO BRASIL</span>
        <h1 className="hero-section__title">
          Conheça o app que mudou para sempre o jeito de lavar seu carro
        </h1>
        <p className="hero-section__subtitle">
          Carro limpo o mês inteiro com total praticidade. Economize tempo de fila e dinheiro no bolso através de uma única assinatura.
        </p>
        <div className="hero-section__actions">
          <button className="btn-cta-green" onClick={onScrollToPlans}>
            <DirectionsCarIcon sx={{ fontSize: 20 }} />
            Assine já
          </button>
          <button className="hero-section__btn-secondary" onClick={() => navigate('/mapa-parceiros')}>
            Ver parceiros
          </button>
        </div>
      </div>
      <div className="hero-section__gradient" />
    </section>
  );
}
